import { forwardRef, memo } from "react";

export const TrendingUpIcon = memo(
  forwardRef(function TrendingUpIcon(
    { size = 26, color = "currentColor", title, className, ...rest },
    ref,
  ) {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden={title ? undefined : true}
        focusable="false"
        className={className}
        {...rest}
      >
        {title ? <title>{title}</title> : null}
        <path
          d="M7.07648 14.3908C6.89719 14.3908 6.71789 14.3248 6.57634 14.1832C6.30268 13.9096 6.30268 13.4566 6.57634 13.183L9.59606 10.1632C9.74704 10.0123 9.94521 9.93676 10.1623 9.95563C10.3699 9.97451 10.5586 10.0877 10.6813 10.267L11.7099 11.8146L15.0599 8.46465C15.3335 8.19098 15.7865 8.19098 16.0601 8.46465C16.3338 8.73831 16.3338 9.19127 16.0601 9.46493L12.0968 13.4283C11.9458 13.5793 11.7476 13.6548 11.5306 13.6359C11.323 13.617 11.1342 13.5038 11.0116 13.3245L9.98296 11.7769L7.57662 14.1832C7.43507 14.3248 7.25578 14.3908 7.07648 14.3908Z"
          fill={color}
        />
        <path
          d="M15.5716 11.5599C15.1847 11.5599 14.8639 11.2391 14.8639 10.8522V9.67257H13.6843C13.2974 9.67257 12.9766 9.35173 12.9766 8.96483C12.9766 8.57793 13.2974 8.25708 13.6843 8.25708H15.5716C15.9585 8.25708 16.2794 8.57793 16.2794 8.96483V10.8522C16.2794 11.2391 15.9585 11.5599 15.5716 11.5599Z"
          fill={color}
        />
        <path
          d="M14.155 21.4683H8.49307C3.36898 21.4683 1.17969 19.279 1.17969 14.1549V8.49295C1.17969 3.36886 3.36898 1.17957 8.49307 1.17957H14.155C19.2791 1.17957 21.4684 3.36886 21.4684 8.49295V14.1549C21.4684 19.279 19.2791 21.4683 14.155 21.4683ZM8.49307 2.59506C4.14279 2.59506 2.59518 4.14266 2.59518 8.49295V14.1549C2.59518 18.5052 4.14279 20.0528 8.49307 20.0528H14.155C18.5053 20.0528 20.0529 18.5052 20.0529 14.1549V8.49295C20.0529 4.14266 18.5053 2.59506 14.155 2.59506H8.49307Z"
          fill={color}
        />
      </svg>
    );
  }),
);

TrendingUpIcon.displayName = "TrendingUpIcon";